

// // import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
// // import Login from './pages/login/Login';
// // // import Home from './pages/home/Home'; // Assuming you have a Home component
// // import Home from "./pages/home/Home"
// // import {
// //   createBrowserRouter,
// //   RouterProvider,
// //   Route,
// //   Outlet,
// //   Navigate,
// // } from "react-router-dom";

// // import { useContext } from "react";
// // import { AuthContext } from './context/authContext';
// // import Quiz from './pages/quiz/Quiz';
// // // import { DarkModeContext } from "./context/darkModeContext";
// // function App() {
// //   // const { darkMode } = useContext(DarkModeContext);
// //   const {currentUser} = useContext(AuthContext);
// //   const ProtectedRoute = ({children}) =>{
// //     if(!currentUser){
// //       return <Navigate to="/login"/>
// //     }
// //     return children;
// //   }
// //   const Layout = () => {
// //     return (
// //       <div>
// //         <h1>hi</h1>
// //         <div style={{ display: "flex" }}>
// //           <Home/>
// //         </div>
// //       </div>
// //     );
// //   };

// //   const router = createBrowserRouter([
// //   {
// //     path: "/",
// //     element: (
// //         <ProtectedRoute>
// //         <Layout />
// //         </ProtectedRoute>
// //     ),
// //     children: [
// //       {
// //         path: "/",
// //         element: <Quiz/>,
// //       },
// //       // {
// //       //   path: "/profile/:id",
// //       //   element: <Profile />,
// //       // },
// //     ],
// //   },
// //     {
// //       path: "/login",
// //       element: <Login />,
// //     },
// //   ]);
// //   return <RouterProvider router={router} />;
// // }



// // import { Routes, Route, useLocation } from 'react-router-dom';
// // import Login from '../src/pages/login/Login.js';
// // import Home from '../src/pages/home/Home.js';
// // import Nav from './pages/nav/Nav.js';
// // import './App.css'; // Make sure this imports your CSS

// // function App() {
// //   const location = useLocation();
// //   const showNav = location.pathname !== '/login';

// //   return (
// //     <div className="min-h-screen bg-gray-100">
// //       {showNav && <Nav />}
// //       <div className={showNav ? 'pt-[100px]' : ''}> {/* Add padding to content when nav is visible */}
// //         <Routes>
// //           <Route path="/login" element={<Login />} />
// //           <Route path="/home" element={<Home />} />
// //           <Route path="/" element={<Home />} /> {/* Add this if you want home as default */}
// //         </Routes>
// //       </div>
// //     </div>
// //   );
// // }

// // export default App;
// // src/App.js

// // import { Routes, Route, useLocation } from 'react-router-dom';
// // import Login from './pages/login/Login';
// // import Home from './pages/home/Home';
// // import Nav from './pages/nav/Nav';
// // import './App.css'; // Make sure this imports your CSS
// // import Payment from './pages/home/Payment';

// // function App() {
// //   const location = useLocation();
// //   const showNav = location.pathname !== '/login';

// //   return (
// //     <div className="app-container">
// //       {showNav && <Nav />}
// //       <main className={`main-content ${showNav ? 'with-nav' : ''}`}>
// //         <Routes>
// //           <Route path="/login" element={<Login />} />
// //           <Route path="/" element={<Home />} />
// //           <Route path="/home" element={<Home />} />
// //           <Route path="/Payment" element={<Payment />} />
// //         </Routes>
// //       </main>
// //     </div>
// //   );
// // }

// // export default App;


// import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
// import Login from './pages/login/Login';
// import Home from './pages/home/Home';
// import Nav from './pages/nav/Nav';
// import Payment from './pages/home/Payment';
// import './App.css';
// import CreateUpdateSuite from './pages/home/CreateUpdateSuite';

// const ProtectedRoute = ({ children }) => {
//   const isAuthenticated = localStorage.getItem('token');

//   return isAuthenticated ? children : <Navigate to="/login" replace />;
// };

// function App() {
//   const location = useLocation();
//   const showNav = location.pathname !== '/login';

//   return (
//     <div className="app-container">
//       {showNav && <Nav />}

//       <main className={`main-content ${showNav ? 'with-nav' : ''}`}>
//         <Routes>
//           <Route path="/" element={<Navigate to="/login" replace />} />
//           <Route path="/login" element={<Login />} />

//           <Route
//             path="/home"
//             element={
//               <ProtectedRoute>
//                 <Home />
//               </ProtectedRoute>
//             }
//           />
//                     <Route
//             path="/create"
//             element={
//               <ProtectedRoute>
//                 <CreateUpdateSuite />
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/payment"
//             element={
//               <ProtectedRoute>
//                 <Payment />
//               </ProtectedRoute>
//             }
//           />
//         </Routes>
//       </main>
//     </div>
//   );
// }

// export default App;


import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Login from './pages/login/Login';
import Home from './pages/home/Home';
import Nav from './pages/nav/Nav';
import Payment from './pages/home/Payment';
import SuiteTypesPage from './pages/home/SuiteTypesPage';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('token');
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
  const location = useLocation();
  const showNav = location.pathname !== '/login';

  return (
    <div className="app-container">
      {showNav && <Nav />}

      <main className={`main-content ${showNav ? 'with-nav' : ''}`}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />

          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />

          {/* Create Suite Route */}
          <Route
            path="/create"
            element={
              <ProtectedRoute>
                <SuiteTypesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/payment"
            element={
              <ProtectedRoute>
                <Payment />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
    </div>
  );
}

export default App;